// @ts-nocheck
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "./btnPermission";
import ElementUI from "element-ui";
import VueSimplehotkey from "vue-simple-hotkey";
Vue.use(VueSimplehotkey);
Vue.use(ElementUI);

import "lib-flexible";
import "element-ui/lib/theme-chalk/index.css";
import "./assets/iconfont/iconfont.css";
import "./assets/icon/iconfont.css";
import "./assets/icon/iconfont.js";
import "font-awesome/css/font-awesome.css";
import "./assets/css/common.css"; //公共样式

import axios from "axios";
import App from "./App.vue";
import router from "./router";
import store from "./vuex";
import i18n from "./i18n/i18n";
import JsEncrypt from "jsencrypt";
import CommonTable from "./components/MGrid/table.vue";
import selectTree from "./components/commonUI/selectTree.vue"; //引入svg组件
import "./svgIcons"; //引入svgIcons

import validate from "./utils/validate";
import authorityUtil from "./utils/AuthorityUtil";
import MUIUtil from "./utils/MUIUtil";
import adminApi from "./api/adminApi";
import superApi from "./api/superApi";
import MGridUtil from "./utils/MGridUtil";
import StringUtil from "./utils/StringUtil";
import Appconstance from "./config/Appconstance";

import { request } from "./utils/ajaxProxy.js";
// import VueFileUpload from 'vue-file-upload' //文件上传

//富文本
import "../static/ueditor/ueditor.config.js";
import "../static/ueditor/ueditor.all.js";
import "../static/ueditor/lang/zh-cn/zh-cn.js";
import "../static/ueditor/ueditor.parse.min.js";

import animate from "animate.css";
import core from "./core/core.config";
Vue.use(core);
Vue.use(animate);
Vue.prototype.$axios = axios; //引入全局注册
Vue.prototype.jsEncrypt = JsEncrypt;
Vue.prototype.MGridUtil = MGridUtil;
Vue.prototype.validate = validate;
Vue.prototype.authorityUtil = authorityUtil;
Vue.prototype.adminApi = adminApi;
Vue.prototype.superApi = superApi;
Vue.prototype.StringUtil = StringUtil;
Vue.prototype.MUIUtil = MUIUtil;
Vue.prototype.request = request;

Vue.prototype.Appconstance = Appconstance;
// Vue.prototype.VueFileUpload = VueFileUpload
Vue.config.productionTip = false;

Vue.component("commonTable", CommonTable); // 引入表格
Vue.component("selectTree", selectTree); // 引入表格
axios.defaults.baseURL = "";
axios.defaults.headers.post["Content-Type"] = "application/json";

//NavigationDuplicated的解决方法
import Router from "vue-router";
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location);
};
//混入函数
Vue.mixin({
  computed: {
    uploadOrderUrl() {
      return `${process.env.API_ROOT}${this.adminApi.commerceOrder.importOrder}`;
    }
  },
  methods: {
    // getAuthHeaders() {
    //   return {
    //     Authorization: `Bearer ${localStorage.token || ""}`
    //   };
    // }
  },
  beforeRouteLeave(to, from, next) {
    // console.log(from);
    // console.log(store.state.excludedComponents);
    if (to.name == store.state.excludedComponents) {
      //是否摧毁本层缓存。
      if (this.$vnode && this.$vnode.data.keepAlive) {
        if (
          this.$vnode.parent &&
          this.$vnode.parent.componentInstance &&
          this.$vnode.parent.componentInstance.cache
        ) {
          if (this.$vnode.componentOptions) {
            var key =
              this.$vnode.key == null
                ? this.$vnode.componentOptions.Ctor.cid +
                  (this.$vnode.componentOptions.tag
                    ? `::${this.$vnode.componentOptions.tag}`
                    : "")
                : this.$vnode.key;
            var cache = this.$vnode.parent.componentInstance.cache;
            var keys = this.$vnode.parent.componentInstance.keys;
            if (cache[key]) {
              if (keys.length) {
                var index = keys.indexOf(key);
                if (index > -1) {
                  keys.splice(index, 1);
                }
              }
              delete cache[key];
            }
          }
        }
      }
      // this.$destroy();
    }
    next();
  }
});
//  获取角色信息，根据用户权限动态加载路由
router.beforeEach((to, from, next) => {
  if (store.getters.token) {
    store.dispatch("setToken", store.getters.token);
    if (to.path === "/login") {
      next({
        path: "/"
      });
    } else {
      if (!store.getters.info.role) {
        // const role = ['/markdown', '/erji', '/erji2', '/siji', '/wuji']
        !(async function getAddRouters() {
          await store.dispatch("getInfo", store.getters.token);
          await store.dispatch("newRoutes", store.getters.info.role);
          // console.log(store.getters.addRouters)
          await router.addRoutes(store.getters.addRouters);
          next({
            path: "/index"
          });
        })();
      } else {
        let is404 = to.matched.some(record => {
          if (record.meta.role) {
            return record.meta.role.indexOf(store.getters.info.role) === -1;
          }
        });
        if (is404) {
          next({
            path: "/404"
          });
          return false;
        }
        next();
      }
    }
  } else {
    if (to.path === "/login") {
      next();
    }
    next({
      path: "/login"
    });
  }
});

Vue.directive("enterNumber", {
  inserted: function(el) {
    el.addEventListener("keypress", function(e) {
      e = e || window.event;
      let charcode = typeof e.charCode === "number" ? e.charCode : e.keyCode;
      let re = /\d/;
      if (
        !re.test(String.fromCharCode(charcode)) &&
        charcode > 9 &&
        !e.ctrlKey
      ) {
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
      }
    });
  }
});
const bus = new Vue();
window.bus = bus;
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: h => h(App),
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js